export default __webpack_public_path__ + "static/media/EsilioPic5.91269f8a.png";